import React from "react";

import { TrayCell } from "../../../probate/components/tray";
import { collectionPath, collectionStatus } from "./requestGroupCollections";
import StatusMarker from "./StatusMarker";

// A request group collection's row in Things to do, which opens the collection's page
const RequestGroupCollectionCell = ({ caseRef, collection, doables }) => (
  <TrayCell
    title={collection.title}
    status={<StatusMarker status={collectionStatus(doables)} />}
    href={collectionPath(caseRef, collection)}
  />
);

export default RequestGroupCollectionCell;
